// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfn_a","ReactCrop--disabled":"bfn_b","ReactCrop--circular-crop":"bfn_c"};